import React, { useEffect, useState } from "react";

import "../styles/FranchisePageStyles/franchiseStyle.css";
import OrderBtn from "../utils/OrderBtn";
import Footer from "../components/Footer";
import { Modal } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../utils/Loader";
import axios from "axios";
import config from "../config";
import swal from "sweetalert";
import { Helmet } from "react-helmet";

const FranchisePage = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [phone_number, setPhoneNumber] = useState("");
  const [error, setError] = useState({
    first_name: "",
    phone_number: "",
  });

  const navigate = useNavigate();

  const validateForm = () => {
    const newErrro = {};
    if (!first_name) {
      newErrro.first_name = "First Name Is Required";
    }


    if (!phone_number) {
      newErrro.phone_number = "Phone Number Is Required";
    } else if (phone_number.length < 10 || phone_number.length > 10) {
      newErrro.phone_number = "Phone Number Must Be 10 Digits";
    } else if (!/^\d{10}$/.test(phone_number)) {
      newErrro.phone_number = "Please Enter a Valid 10-Digit Phone Number.";
    }

    setError(newErrro);
    console.log("error", newErrro);
    return Object.keys(newErrro).length === 0;
  };

  const onFormSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      // navigate(`${config.appUrl}/franchise-form?first_name=${first_name}&last_name=${last_name}&phone_number=${phone_number}`)

      navigate(`${config.appUrl}/franchise-form`, {
        state: { data: { first_name, last_name, phone_number } },
      });
    }
  };

  // geting franchise page data
  const [isLoading, setIsLoading] = useState(false);
  const [banner_title, setBannerTitle] = useState("");
  const [banner_description, setBannerDesc] = useState("");
  const [banner_subtitle, setBannerSubTitle] = useState("");
  const [banner_image, setBannerImg] = useState("");

  const [get_title, setGetTitle] = useState("");
  const [get_description, setGetDesc] = useState("");
  const [get_image, setGetImg] = useState("");

  const [branding_established, setBrandEst] = useState("");
  const [branding_locations, setBrandLoc] = useState("");
  const [branding_happy_customers, setBrandHappyCust] = useState("");

  const [serving_title, setServTitle] = useState("");
  const [serving_description, setServDesc] = useState("");
  const [serving_image, setServImg] = useState("");

  const [who_title, setWhoTitle] = useState("");
  const [who_subtitle, setWhoSubTitle] = useState("");
  const [who_description, setWhoDesc] = useState("");
  const [who_bg_image, setWhoBgImg] = useState("");

  const [client_name, setClientName] = useState("");
  const [client_description, setClientDesc] = useState("");
  const [client_image, setClientImg] = useState("");
  const [client_review, setClientRev] = useState("");

  const [lets_title, setLetsTitle] = useState("");
  const [lets_subtitle, setLetsSubTitle] = useState("");
  const [lets_description, setLetsDesc] = useState("");
  const [lets_bg_image, setLetsBgImg] = useState("");
  const [lets_info, setLetsInfo] = useState("");

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await axios({
        method: "get",
        url: `${config.apiUrl}/franchise-data`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        // console.log("data", res.data.data)
        setBannerTitle(res.data.data?.banner_title);
        setBannerDesc(res.data.data?.banner_description);
        setBannerSubTitle(res.data.data?.banner_subtitle);
        setBannerImg(res.data.data?.banner_image);
        setGetTitle(res.data.data?.get_title);
        setGetDesc(res.data.data?.get_description);
        setGetImg(res.data.data?.get_image);
        setBrandEst(res.data.data?.branding_established);
        setBrandLoc(res.data.data?.branding_locations);
        setBrandHappyCust(res.data.data?.branding_happy_customers);
        setServTitle(res.data.data?.serving_title);
        setServDesc(res.data.data?.serving_description);
        setServImg(res.data.data?.serving_image);
        setWhoTitle(res.data.data?.who_title);
        setWhoSubTitle(res.data.data?.who_subtitle);
        setWhoDesc(res.data.data?.who_description);
        setWhoBgImg(res.data.data?.who_bg_image);
        setClientName(res.data.data?.client_name);
        setClientDesc(res.data.data?.client_description);
        setClientImg(res.data.data?.client_image);
        setClientRev(res.data.data?.client_review);
        setLetsTitle(res.data.data?.lets_title);
        setLetsSubTitle(res.data.data?.lets_subtitle);
        setLetsDesc(res.data.data?.lets_description);
        setLetsBgImg(res.data.data?.lets_bg_image);
        setLetsInfo(res.data.data?.lets_info);
        // console.log(res.data.data?.client_image);
        setIsLoading(false);
      });
    } catch (error) {
      setIsLoading(false);
      console.log("frachise data", error);
    }
  };

  return (
    <>
      {/* <Helmet>
        <title>Own Top Ice Cream Franchise in Canada | Rollz Ice Cream</title>
        <meta
          name="description"
          content="Embark on your journey to sweet success by owning a Rollz Ice Cream Franchise across Canada. Join this delectable business opportunity today!"
        />
        <meta
          property="og:title"
          content="Own Top Ice Cream Franchise in Canada | Rollz Ice Cream"
        />
        <meta
          property="og:description"
          content="Embark on your journey to sweet success by owning a Rollz Ice Cream Franchise across Canada. Join this delectable business opportunity today!"
        />
      </Helmet> */}
      <Helmet>
        <meta 
          name="keywords"
          content="ice cream franchise for sale, how to start a rolled ice cream business, profitable dessert franchises Canada, Canadian ice cream franchise for sale, invest in ice cream franchise Canada"
        />
        <meta 
          name="title"
          content="Ice Cream Franchise Canada | Own a Profitable Dessert Brand"
        />
        <meta 
          name="description"
          content="Looking for a profitable dessert franchise in Canada? Invest in Rollz Ice CreamCanadas fastest-growing ice cream franchise opportunity!"
        />
      </Helmet>

      {isLoading && <Loader />}
      <div className="franchise_page">
        {/* Header Section    */}
        <section className="common_container franchise_section1">
          <div className="d-flex flex-column flex-column-reverse flex-md-row align-items-center justify-content-center auto_container franchise_container">
            <div className="col-12 col-md-6 d-flex flex-column align-items-center justify-content-center franchise_header_info pb-5">
              <h1 className="hero_heading mb-4">
                {/* Join Our Rollz Ice Cream Franchise. */}
                {banner_title}
              </h1>
              <p className="text-white mb-4">
                {/* There’s no limit to the rewards of franchising with one of the
                fastest-growing and most exciting dessert brands! Rollz Ice
                Cream is rolling out the fun, and we’re looking for passionate
                and driven franchise owners to join our family. With a proven
                business model, vibrant atmosphere, and a product that brings
                joy to all ages, Rollz Ice Cream is the perfect opportunity for
                those ready to take the sweet route to success. */}
                {banner_description}
              </p>
              <div className="w-100">
                <h4 className="text-start mb-4">
                  {/* Ready to join the Rollz family? */}
                  {banner_subtitle}
                </h4>
              </div>

              <div className="order-online">
                <Link
                  className="blue-btn hero-anchor"
                  onClick={() => setShowPopup(true)}
                >
                  <div className="order-online-trans-1"></div>
                  <div className="order-online-trans-2"></div>
                  Start here
                </Link>
              </div>
            </div>
            <div className="col-12 col-md-6 d-flex align-items-start justify-content-start frachise_img pb-2 pb-md-0 ps-md-5">
              <img
                src={banner_image}
                alt="franchImg1"
                className="img-fluid"
                loading="lazy"
              ></img>
            </div>
          </div>
        </section>

        {/* Get to know more  */}
        <section className="franchise_info_container">
          <div className="franchise_contianer_wrapper">
            <div className="col-12 d-flex flex-column flex-md-row franchise_info">
              <div className="col-12 col-md-6 d-flex align-items-center justify-content-center frachise_img2 mb-4 mb-md-0 pe-0 pe-md-5">
                <img
                  src={get_image}
                  alt="franchImg2"
                  className=""
                  loading="lazy"
                ></img>
              </div>
              <div className="col-12 col-md-6 d-flex flex-column align-items-center justify-content-center">
                <h1 className="hero_heading mb-4">
                  {/* Get to Know Rollz Ice Cream */}
                  {get_title}
                </h1>
                {/* <p className="mb-4">
                  Since 2017, Rollz Ice Cream has been dedicated to creating
                  joyful, flavorful experiences for our customers. We combine
                  the fun of Thai rolled ice cream with Canadian tastes, making
                  it a treat for all ages!
                </p>
                <p className="mb-4">
                  With a unique business model, premium quality, and an engaging
                  brand, Rollz Ice Cream offers one of the most exciting
                  franchise opportunities in the dessert space. Today, Rollz has
                  expanded to over 17 locations across Canada, and we’re growing
                  rapidly. Most of our franchises are independently owned and
                  operated by passionate entrepreneurs, many of whom are
                  family-run businesses with long-term success. We provide the
                  tools, training, and support to help you start strong and grow
                  your business with ease
                </p> */}
                <p className="mb-4">{get_description}</p>

                <div className="w-100 franchise_info_btn">
                  <OrderBtn text={"Our Story"} url="/our-story" />
                  <p className="text-end mt-4">
                    *For more info about us read our stories
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Branding Sec  */}
        <section className="franchise_branding_container">
          <div className="text-center franchise_branding">
            <h1 className="franchise_brand_title mb-5">Branding Strength</h1>
            <div className="d-flex flex-column flex-md-row align-items-center justify-content-start franchise_brandings gap-2">
              <div className="col-12 col-md-4 col-sm-6 franchise_brand mb-3 mb-md-0">
                {/* <h3>2017</h3> */}
                <h3 className="mb-2">{branding_established}</h3>
                <h5>Established</h5>
              </div>
              <div className="col-12 col-md-4 col-sm-6 franchise_brand mb-3 mb-md-0">
                {/* <h3>17+</h3> */}
                <h3 className="mb-2">{branding_locations}+</h3>
                <h5>locations </h5>
              </div>
              <div className="col-12 col-md-4 col-sm-6 franchise_brand mb-3 mb-md-0">
                <h3 className="mb-2">{branding_happy_customers}+</h3>
                <h5>Happy Customers </h5>
              </div>
            </div>
          </div>
        </section>

        {/* Serving Up Sec  */}
        <section className="franchise_serving_container">
          <div className="flex-column flex-md-row franchise_serving franchise_serving_info">
            <div className="col-12 col-md-5 d-flex flex-column align-items-center justify-content-start franchise_sweet_info">
              <h1 className="hero_heading mb-4">
                {/* Serving Up Sweet Moments, Your Way */}
                {serving_title}
              </h1>
              {/* <p className="mb-4">
                Our creations speak for themselves. We’re proud to be the home
                of rolled ice cream—where creativity meets indulgence. Whether
                you’re craving a creamy Premium flavour, enjoying the refreshing
                taste of our Fruit Flavours, or delighting in one of our unique
                Mixed or Desi Flavours, Rollz Ice Cream has something for
                everyone. It's no wonder our loyal customers keep coming back
                for more.
              </p>
              <p className="mb-4">
                When we say "Roll It Your Way," we mean more than just a custom
                dessert made exactly how you like it. We’re known for our
                welcoming atmosphere and our dedication to crafting
                unforgettable experiences. From the first scoop to the last
                bite, we treat every guest like family and ensure everyone
                leaves with a smile.
              </p> */}
              <p className="mb-4">{serving_description}</p>
              <div className="franchise_serving_btn">
                <OrderBtn text={"Start here"} url="/franchise-form" />
              </div>
            </div>

            <div className="col-12 col-md-5 text-center franchise_serving_image mb-2 mb-md-0 pt-5 pt-md-0">
              <img
                src={serving_image}
                alt="rollz img"
                className="img-fluid"
                loading="lazy"
              ></img>
            </div>
          </div>
        </section>

        {/* looking for banner */}
        <section className="franchise_looking_container">
          <div
            className="franchise_looking_wrapper"
            style={{
              padding: "50px",
              maxWidth: "91%",
              margin: "auto",
              mixBlendMode: "normal",
              backgroundImage: `linear-gradient(#00000080, #00000080), url(${who_bg_image})`,
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <div className="flex-column flex-md-row franchise_looking_info">
              <div className="col-12 col-md-6 d-flex justify-content-start aling-items-start">
                <h2 className="text-white franchise_title mb-4">
                  {/* Who We’re Looking For */}
                  {who_title}
                </h2>
              </div>

              <div className="col-12 col-md-6 d-flex flex-column align-items-start justify-content-end franchise_partner_info">
                <h3 className="text-white mb-4">
                  {/* Our Ideal Candidate */}
                  {who_subtitle}
                </h3>
                {/* <p>
                  If becoming a Rollz Ice Cream franchisee sounds as sweet as
                  our signature rolled ice cream, we’d love to hear from you!
                  Our ideal candidate is a motivated, results-driven individual
                  with a passion for delivering great experiences. We’re looking
                  for self-starters who are excited about running their own
                  business and have the resources and infrastructure to ensure
                  success. Previous experience in the food industry, especially
                  in the dessert or QSR space, is a plus, as is a proven
                  commitment to exceptional customer service.
                </p> */}
                <p>{who_description}</p>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials section  */}
        <section className="franchise_testimonials_container">
          <div className="flex-column flex-md-row franchise_testimonials_wrapper">
            <div className="col-12 col-md-5 franchise_testimonials_images mb-2 mb-md-0 me-md-4">
              {/* <img
                src={client_image}
                className="img-fluid testimonial_img"
                alt="client image"
                loading="lazy"
              ></img> */}
              {client_image ? (
                // Check if the client_image is a URL (string)
                typeof client_image === "string" ? (
                  client_image.endsWith(".jpg") ||
                  client_image.endsWith(".jpeg") ||
                  client_image.endsWith(".png") ||
                  client_image.endsWith(".gif") ? (
                    <img
                      src={client_image}
                      className="img-fluid testimonial_img"
                      alt="client image"
                      loading="lazy"
                    />
                  ) : client_image.endsWith(".mp4") ||
                    client_image.endsWith(".mov") ||
                    client_image.endsWith(".webm") ? (
                    <video
                      className="img-fluid testimonial_img"
                      controls
                      loading="lazy"
                    >
                      <source src={client_image} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  ) : null
                ) : // If client_image is a File object
                client_image.type.startsWith("image/") ? (
                  <img
                    src={URL.createObjectURL(client_image)}
                    className="img-fluid testimonial_img"
                    alt="client image"
                    loading="lazy"
                  />
                ) : client_image.type.startsWith("video/") ? (
                  <video
                    className="img-fluid testimonial_img"
                    controls
                    loading="lazy"
                  >
                    <source
                      src={URL.createObjectURL(client_image)}
                      type={client_image.type}
                    />
                    Your browser does not support the video tag.
                  </video>
                ) : null
              ) : null}

              <div className="franchise_client_info">
                <h3 className="text-white mb-2">
                  {/* Parah Lee */}
                  {client_name}
                </h3>
                <p>
                  {/* Parah Lee became a Rollz Ice Cream franchisee in 2018 and now
                  operates 12 locations across the region. */}
                  {client_description}
                </p>
              </div>
            </div>
            <div className="col-12 col-md-7 franchise_testimonials_details">
              <h4
                className="mb-2 mb-md-4"
                style={{ color: `var(--font-primary)` }}
              >
                {/* "Rollz Ice Cream has always been a part of my family's
                celebrations, and I’m excited to share the joy with others.
                Being a part of this growing brand and serving our unique rolled
                ice cream has been a rewarding experience. I’m proud to create a
                fun, community-focused space where people of all ages can enjoy
                a sweet moment together." */}
                {client_review}
              </h4>
              {/* <p>Parah Lee – Franchisee</p> */}
              <p className="fw-bold">{client_name} – Franchisee</p>
            </div>
          </div>
        </section>

        {/* Lets Get Started  */}
        <section className="franchise_started_container">
          <div className="franchise_started_wrapper">
            <div
              className="d-flex flex-column align-items-center justify-content-center franchise_started_section"
              style={{
                width: "100%",
                height: "40vh",
                minHeight: "400px",
                backgroundColor: `var(--heading-color)`,
                textAlign: "center",
                backgroundImage: `linear-gradient(#00000080, #00000080), url(${lets_bg_image})`,
                backgroundPosition: "0 0 50%",
                backgroundSize: "auto, cover",
              }}
            >
              <div className="franchise_started_section_content">
                <h2 className="text-white mb-2">
                  {/* Let's Get Started */}
                  {lets_title}
                </h2>
                <h5 className="text-white mb-4">
                  {/* Your Path to Joining the Rollz Ice Cream Family Starts Here */}
                  {lets_subtitle}
                </h5>
                <p className="mb-4">
                  {/* Getting started with Rollz Ice Cream is simple. Just fill out
                  our easy Initial Inquiry Form, and a member of our franchising
                  team will reach out to you soon. We look forward to exploring
                  how you can bring the joy of rolled ice cream to your
                  community! */}
                  {lets_description}
                </p>
                <div className="franchise_started_orderBtn">
                  <OrderBtn text={"Start Here"} url="/franchise-form" />
                </div>
              </div>
            </div>

            <div className="franchise_started_footer">
              <div className="franchise_started_footer_container">
                <p>
                  {/* The information contained on this website does not constitute
                  an offer to sell a franchise. An offer to sell a franchise can
                  only be made through delivery of a Franchise Disclosure
                  Document. None of the communications made through this website
                  should be construed as an offer to sell a franchise */}
                  {lets_info}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* <Footer color="#ffdbe2" /> */}
      </div>

      <Modal
        show={showPopup}
        size="lg"
        centered
        className="modal basic_details_modal"
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Basic Details</h5>
          <button
            type="button"
            title="Close Modal"
            onClick={() => {
              setShowPopup(false);
            }}
            className="btn-modal-close text-white"
          >
            <span className="btn-modal-span">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <h5 className="">Please Enter Your Basic Details</h5>
          <form onSubmit={onFormSubmit}>
            <div className="d-flex flex-column flex-wrap align-items-center justify-content-start py-4">
              <div className="col-12 d-flex flex-wrap align-items-center justify-content-start gap-4 mb-4">
                <div className="col-12 col-sm-5 franchise_form_feilds">
                  <label className="mb-1 ps-1">
                    First Name <span className="text-danger">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter First Name"
                    value={first_name}
                    onChange={(e) => setFirstName(e.target.value)}
                  ></input>
                  {error.first_name && (
                    <span className="error ms-0 px-2 py-1">
                      <i className="bi bi-exclamation-circle-fill me-1"></i>
                      {error.first_name}
                    </span>
                  )}
                </div>
                <div className="col-12 col-sm-5 franchise_form_feilds">
                  <label className="mb-1 ps-1">
                    Last Name {" "}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Last Name"
                    value={last_name}
                    onChange={(e) => setLastName(e.target.value)}
                  ></input>
                 
                </div>
              </div>
              <div className="col-12 d-flex flex-wrap align-items-center justify-content-start franchise_form_feilds mb-4">
                <div className="col-12 col-sm-5">
                  <label className="mb-1 ps-1">
                    Phone Number <span className="text-danger">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Phone Number"
                    value={phone_number}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  ></input>
                  {error.phone_number && (
                    <span className="error ms-0 px-2 py-1">
                      <i className="bi bi-exclamation-circle-fill me-1"></i>
                      {error.phone_number}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-12 d-flex flex-wrap align-items-center justify-content-center basic_details_modal_btn">
                {/* <OrderBtn text="Next" url="/franchise-form" /> */}
                <div className="order-online">
                  <button
                    className="text-white blue-btn hero-anchor"
                    type="submit"
                  >
                    <div className="order-online-trans-1"></div>
                    <div className="order-online-trans-2"></div>
                    Next
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default FranchisePage;
